import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/new-product")({
  component: () => <Outlet />,
});
